<template>
	<div class="rooms">
		<tabs-component :tabs="tabs"></tabs-component>
		<v-layout row wrap>
			<v-flex md5 class="pr-3 body-border-right">
				<filter-list class="mb-3" v-bind:value="filterValue" v-on:selected-filter="selectedFilter" />
				<table-run v-bind:columns="columns"
						   v-bind:rows="rows"
						   v-bind:include-delete="false"
						   v-bind:include-search="false"
						   v-bind:include-export-to-excel="false"
						   v-bind:include-options="true"
						   v-bind:include-switch="true"
						   v-bind:include-settings="true"
						   v-bind:go-to-settings-page="`/`"
						   v-bind:include-delete-single="true"
						   v-bind:selectable="false"
						   v-on:on-sortable-event="columnSortableEvent"
						   class="no-selectable-table no-search-table">
					<template slot="rows" scope="props">
						<td>
							<button type="button"
									v-on:click="showRooms(props.row.rooms, props.row.name, props.row.quantity)"
									class="button-transparent">
								{{props.row.name}}
							</button>
						</td>
						<td>
							<button type="button"
									v-on:click="showRooms(props.row.rooms, props.row.name, props.row.quantity)"
									class="button-transparent">
								{{props.row.quantity}}
							</button>
						</td>
					</template>    
				</table-run>
			</v-flex>
			<v-flex md7 class="pl-3">
				<v-layout row wrap class="body-border-bottom">
					<v-flex md6></v-flex>
					<v-flex md6 class="text-xs-right mb-3">
						<button-create :text="'Habitación'"></button-create>
					</v-flex>
				</v-layout>
				<v-layout row wrap justify-start>
					<h3 class="semibold-blue-title-20" v-if="roomsQuantity">{{ roomTypeName }} - {{ roomsQuantity }}</h3>
				</v-layout>
				<v-layout row wrap justify-start>
					<room-number-list v-for="room in rooms" :key="room.id" :link="`/rooms/${room.id}`" :room="room"></room-number-list>
				</v-layout>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import TableRun from 'table-run';
import ButtonCreate from '@/components/shared/ButtonCreate';
import FilterList from '@/components/shared/FilterList';
import RoomNumberList from '@/components/shared/RoomNumberList';
import TabsComponent from '@/components/shared/TabsComponent';

function columnSortableEvent(id) {
	setTimeout(() => {
		let newData = [];
		const newColumn = this.columns.filter(column => column.id === id);
		newColumn[0].isSortable = newColumn[0].isSortable.down ?
		{ down: false, up: true } : { down: true, up: false };
		const columnName = newColumn[0].code;
		if (newColumn[0].isSortable.up) {
			newData = this.rows.sort((a, b) => {
				if (typeof a[columnName] === 'number' && typeof b[columnName] === 'number') {
					return a[columnName] - b[columnName];
				}
				return a[columnName].charCodeAt() - b[columnName].charCodeAt();
			});
		} else {
			newData = this.rows.sort((a, b) => {
				if (typeof a[columnName] === 'number' && typeof b[columnName] === 'number') {
					return b[columnName] - a[columnName];
				}
				return b[columnName].charCodeAt() - a[columnName].charCodeAt();
			});
		}
		this.rows = newData;
	}, 300);
}

function selectedFilter(filter) {
	this.filterValue = filter.id;
}

function showRooms(rooms, name, quantity) {
	this.rooms = rooms;
	this.roomTypeName = name;
	this.roomsQuantity = quantity;
}

export default {
	name: 'other-enviroments',
	components: {
		ButtonCreate,
		FilterList,
		RoomNumberList,
		TableRun,
		TabsComponent,
	},
	data() {
		return {
			columns: [
				{ id: 1, name: 'Room type', code: 'name', isSortable: { down: true, up: false } },
				{ id: 2, name: 'Quantity', code: 'quantity', isSortable: { down: true, up: false } },
			],
			filterValue: 1,
			rows: [
				{
					id: 1,
					name: 'Deluxe Room Queen',
					quantity: 8,
					flagactive: 1,
					rooms: [
						{
							id: 101,
							isAssigned: true,
							isSelected: false,
						},
						{
							id: 102,
							isAssigned: false,
							isSelected: false,
						},
					],
				},
				{
					id: 2,
					name: 'Deluxe Suite Queen',
					quantity: 25,
					flagactive: 1,
					rooms: [
						{
							id: 103,
							isAssigned: true,
							isSelected: false,
						},
						{
							id: 104,
							isAssigned: false,
							isSelected: false,
						},
					],
				},
				{
					id: 3,
					name: 'Deluxe Suite Twin',
					quantity: 3,
					flagactive: 1,
					rooms: [
						{
							id: 105,
							isAssigned: true,
							isSelected: false,
						},
						{
							id: 106,
							isAssigned: false,
							isSelected: false,
						},
					],
				},
				{
					id: 4,
					name: 'Executive Suite Queen',
					quantity: 3,
					flagactive: 1,
					rooms: [
						{
							id: 107,
							isAssigned: true,
							isSelected: false,
						},
						{
							id: 108,
							isAssigned: false,
							isSelected: false,
						},
					],
				},
				{
					id: 5,
					name: 'Superior Suite Queen',
					quantity: 1,
					flagactive: 1,
					rooms: [
						{
							id: 109,
							isAssigned: true,
							isSelected: false,
						},
						{
							id: 110,
							isAssigned: false,
							isSelected: false,
						},
					],
				},
			],
			rooms: [],
			roomTypeName: '',
			roomsQuantity: null,
			tabs: [
				{
					id: 1,
					title: 'Rooms',
					link: '/rooms',
				},
				{
					id: 2,
					title: 'Other enviroments',
					link: '/other-enviroments',
				},
			],
		};
	},
	methods: {
		columnSortableEvent,
		selectedFilter,
		showRooms,
	},
};
</script>



// WEBPACK FOOTER //
// OtherEnviroments.vue?7775a00c